import { style } from '@vtex/admin-ui'

export const wrapper = style({
  backgroundColor: 'rgba(255, 255, 255, 0.15)',
  borderRadius: '$base',
  padding: '$space-05 6px',
})
